import {IRange} from "@pg-design/inputs-module";

import {AREA_MAX_VALUE} from "../types/AreaMaxValue";

export const getAreaFilterLimitedValues = (value: IRange<string>): IRange<string> => {
    const lowerValue = Number(value.lower) > AREA_MAX_VALUE ? AREA_MAX_VALUE.toString() : value.lower;
    const upperValue = AREA_MAX_VALUE < Number(value.upper) ? AREA_MAX_VALUE.toString() : value.upper;

    return {lower: lowerValue, upper: upperValue};
};
import {IRange} from "@pg-design/inputs-module";

import {AREA_MAX_VALUE} from "../types/AreaMaxValue";

export const getAreaFilterLimitedValues = (value: IRange<string>): IRange<string> => {
    const lowerValue = Number(value.lower) > AREA_MAX_VALUE ? AREA_MAX_VALUE.toString() : value.lower;
    const upperValue = AREA_MAX_VALUE < Number(value.upper) ? AREA_MAX_VALUE.toString() : value.upper;

    return {lower: lowerValue, upper: upperValue};
};
